import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EnabledServicesComponent } from "@onsip/web/features/administrators/pbx-settings/enabled-services/enabled-services.component";
import { EnabledServicesRoutingModule } from "@onsip/web/features/administrators/pbx-settings/enabled-services/enabled-services-routing.module";
import { MatButtonModule } from "@angular/material/button";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  declarations: [EnabledServicesComponent],
  imports: [
    CommonModule,
    EnabledServicesRoutingModule,
    MatButtonModule,
    RouterModule,
    TranslateModule
  ]
})
export class EnabledServicesModule {}
